import { useSelector } from 'react-redux';
import { getCurrentUserEducation, isGuestSelector } from '../../user/currentUserSelector';
import useLockScreenOrientationPortrait from './useLockScreenOrientationPortrait';
import { hasSeen } from '../../../common/users/userEducationUtil';
import { ONBOARDING_EDUCATION_CODES } from '../../../common/users/userEducationConstants';

/**
 * If the user is still completing their onboarding, don't let them rotate the screen,
 * otherwise it'll get in the way of the onboarding process.
 */
export default function useLockScreenOrientationPortraitDuringOnboarding() {
    const currentUserEducation = useSelector(getCurrentUserEducation);
    const isGuest = useSelector(isGuestSelector);

    useLockScreenOrientationPortrait(
        !isGuest && !hasSeen(currentUserEducation, ONBOARDING_EDUCATION_CODES.DESKTOP_ONBOARDING),
    );
}
